import React from "react";
import { Box } from "@mui/material";
import Form from "./form";
import { companyManagementUrl } from "../../../config";
import DynamicTableForJson from "../../../data/DynamicTable/dynamicTableForJson";

const base_url = companyManagementUrl.uri;

const CompanySettings = () => {
  const actions = {
    entity: localStorage.getItem("SelectedRight"),
    //entity:"CompanySettings",    
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    dataObject: {
      ignoreFields: ["UpdateDate", "CreateDate"],
      objectName: "companySettings",
      parameters: "",
    },
    showStatus: true,
  };

  return (
    <Box m="20px">
      <DynamicTableForJson
        title="Company Settings Management"
        subtitle="Manage Company Settings"
        FormComponent={Form}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};

export default CompanySettings;
